/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ActiveSessionDto { 
    id?: number;
    guid?: string;
    startDateTime?: string;
    endDateTime?: string;
    vehicleRegistrationNo?: string | null;
    status?: string | null;
    employeeName?: string | null;
    sessionType?: string | null;
    locationId?: number;
    locationCode?: string | null;
}

